import type { CassettoFrequency } from '@trackeat/shared';

export interface CassettoDef {
  frequency: CassettoFrequency;
  label: string;
  color: string; // bordo / intestazione card
  emoji: string;
}

// I 3 cassetti del registro GSI/Cambusa (vedi spec cleaning-cassetti).
export const CASSETTI: CassettoDef[] = [
  { frequency: 'giornaliera', label: 'Giornaliera', color: '#16a34a', emoji: '🟩' },
  { frequency: 'settimanale', label: 'Settimanale', color: '#2563eb', emoji: '🟦' },
  { frequency: 'mensile', label: 'Mensile', color: '#7c3aed', emoji: '🟪' },
];

const FREQ_HOURS: Record<string, number> = {
  giornaliera: 24,
  settimanale: 168,
  mensile: 720,
  trimestrale: 2160,
  semestrale: 4320,
  annuale: 8760,
};

interface VoceLike {
  id: string;
  frequency?: string | null;
}

// Le cadenze fuori dai 3 cassetti (trimestrale/annuale/a_chiamata) confluiscono
// nel cassetto Mensile, così nessuna voce esistente sparisce dalla vista.
export function cassettoOf(freq?: string | null): CassettoFrequency {
  if (freq === 'giornaliera' || freq === 'settimanale' || freq === 'mensile') return freq;
  return 'mensile';
}

export function groupVociByCassetto<T extends VoceLike>(voci: T[]): Record<CassettoFrequency, T[]> {
  const out: Record<CassettoFrequency, T[]> = { giornaliera: [], settimanale: [], mensile: [] };
  for (const v of voci) out[cassettoOf(v.frequency)].push(v);
  return out;
}

// Il cassetto è "fatto" per il periodo se TUTTE le sue voci risultano pulite
// entro la finestra della frequenza. Cassetto vuoto = non fatto (niente da fare).
export function isCassettoDone(
  voci: VoceLike[],
  lastDoneMs: Map<string, number>,
  frequency: CassettoFrequency,
  nowMs: number,
): boolean {
  if (voci.length === 0) return false;
  const windowH = FREQ_HOURS[frequency] ?? 24;
  return voci.every((v) => {
    const last = lastDoneMs.get(v.id);
    if (!last) return false;
    return (nowMs - last) / 3_600_000 < windowH;
  });
}
